import React from 'react';
import { Box, Avatar, Typography } from '@mui/material';
import { formatDistanceToNow } from 'date-fns';
import { Message } from '../../../types';
import { users } from '../../../data/sampleData';
import { MessageContent } from './MessageContent';

interface MessageListProps {
  messages: Message[];
  messagesEndRef: React.RefObject<HTMLDivElement>;
}

export const MessageList: React.FC<MessageListProps> = ({
  messages,
  messagesEndRef,
}) => {
  const currentUser = users[0]; // Current user is always the first user

  return (
    <Box 
      sx={{ 
        flex: 1,
        overflow: 'auto',
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        scrollBehavior: 'smooth',
      }}
    >
      {messages.map((message) => {
        const isCurrentUser = message.senderId === currentUser.id;
        const sender = users.find(u => u.id === message.senderId);
        if (!sender) return null; // Skip rendering if sender not found

        return (
          <Box
            key={message.id}
            sx={{
              display: 'flex',
              flexDirection: isCurrentUser ? 'row-reverse' : 'row',
              gap: 1,
              alignItems: 'flex-start',
            }}
          >
            <Avatar
              src={sender.avatar}
              alt={sender.name}
              sx={{ width: 32, height: 32 }}
            />
            <Box
              sx={{
                maxWidth: '70%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: isCurrentUser ? 'flex-end' : 'flex-start',
              }}
            >
              <MessageContent 
                message={message}
                isCurrentUser={isCurrentUser}
              />
              <Typography 
                variant="caption" 
                color="text.secondary"
                sx={{ mt: 0.5 }}
              >
                {formatDistanceToNow(new Date(message.timestamp), { addSuffix: true })}
              </Typography>
            </Box>
          </Box>
        );
      })}
      <div ref={messagesEndRef} />
    </Box>
  );
};